import { render, staticRenderFns } from "./TermsGeolocation.vue?vue&type=template&id=1547472c&scoped=true&"
import script from "./TermsGeolocation.vue?vue&type=script&lang=js&"
export * from "./TermsGeolocation.vue?vue&type=script&lang=js&"
import style0 from "./TermsGeolocation.vue?vue&type=style&index=0&id=1547472c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547472c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
